import { createFileRoute } from '@tanstack/react-router';
import { ContactPage } from '../../pages/ContactPage';
import { staticPageHead } from '../../lib/seo/staticPageHead';

export const Route = createFileRoute('/_site/contact')({
  head: () =>
    staticPageHead({
      path: '/contact',
      title: 'Contact AnyAPI',
      description:
        'Reach AnyAPI Labs, Inc. by email, Discord, or GitHub. Support, billing, partnerships, and press.',
      og: { title: 'Contact AnyAPI' },
    }),
  component: ContactPage,
});
